import { render } from "./PoliticasReposicion.vue?vue&type=template&id=7b17f546"
import script from "./PoliticasReposicion.vue?vue&type=script&lang=js"
export * from "./PoliticasReposicion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__